//hooks/useVoiceCitations.js

import { useState, useEffect } from 'react';

const useVoiceCitations = (apiUrl, databaseId, collectionId) => {
  const [voiceDatabase, setVoiceDatabase] = useState(null);
  const [voiceCollection, setVoiceCollection] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCitationsData = async () => {
      try {
        const dbRes = await fetch(`${apiUrl}/voice-databases/${databaseId}`);
        const dbData = await dbRes.json();
        setVoiceDatabase(dbData);

        const collectionRes = await fetch(`${apiUrl}/voice-collections/${collectionId}`);
        const collectionData = await collectionRes.json();
        setVoiceCollection(collectionData.data);
      } catch (error) {
        console.error('[useVoiceCitations] Error fetching citation data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCitationsData();
  }, [apiUrl, databaseId, collectionId]);

  return { voiceDatabase, voiceCollection, loading };
};

export default useVoiceCitations;
